import React from 'react';
import yaml from 'js-yaml';
// renderers is imported separately so Markdoc isn't sent to the client
import Markdoc, {renderers} from '@markdoc/markdoc'

import {getSchema, defaultObject} from '/vercel/path0/.dev/node_modules/@markdoc/next.js/src/runtime.js';
/**
 * Schema is imported like this so end-user's code is compiled using build-in babel/webpack configs.
 * This enables typescript/ESnext support
 */
const config = {};
import * as tags from '/vercel/path0/.dev/markdoc/tags.tsx'
import * as nodes from '/vercel/path0/.dev/markdoc/nodes.tsx'
import * as functions from '/vercel/path0/.dev/markdoc/functions.ts'
const schema = {
tags: defaultObject(tags),
nodes: defaultObject(nodes),
functions: defaultObject(functions),
...defaultObject(config),
};

/**
 * Source will never change at runtime, so parse happens at the file root
 */
const source = "---\ntitle: Rating\ndescription: Submit rating values for items.\nslug: rating-component\n---\n\nThe Rating Component lets users rate items in your apps. They can tap and drag through the different values and the rating will be written to your [Data Source](/docs/reference/data-sources/).\n\n## How to add a Rating component\n\n1. Click on the plus symbol in the **Screen** panel.\n2. Under **Insert Component**, select **Rating**.\n\n## Data\n\nSelect which column to store the users' ratings in the **Save to** field. The Rating component will write a simple number value to your data source. If you want ratings to be specific for each user then you can use [User-specific Columns](/docs/user-specific-columns).\n\n{% figure src=\"/docs/reference/components/rating-component/image%20(4).png\" caption=\"\" /%}\n\n## Options\n\nDetermine the **Max Rating** to accept. This ranges from 3 to 5.\n\n{% callout title=\"\" %}\nThe Rating component is especially useful in [Forms](/docs/forms). You can collect the users' individual ratings for an item. Learn more about [Rollup Columns](/docs/rollup) to then determine average ratings.\n{% /callout %}\n";
const filepath = "/reference/components/rating-component.md";
const ast = Markdoc.parse(source);

/**
 * Like the AST, frontmatter won't change at runtime, so it is loaded at file root.
 * This unblocks future features, such a per-page dataFetchingFunction.
 */
const frontmatter = ast.attributes.frontmatter
  ? yaml.load(ast.attributes.frontmatter)
  : {};

const {components, ...rest} = getSchema(schema)

export async function getStaticProps(context) {
  const partials = {};

  // Ensure Node.transformChildren is available
  Object.keys(partials).forEach((key) => {
    partials[key] = Markdoc.parse(partials[key]);
  });

  const cfg = {
    ...rest,
    variables: {
      ...(rest ? rest.variables : {}),
      // user can't override this namespace
      markdoc: {frontmatter},
      // Allows users to eject from Markdoc rendering and pass in dynamic variables via getServerSideProps
      ...(context.variables || {})
    },
    partials,
    source,
  };

  /**
   * transform must be called in dataFetchingFunction to support server-side rendering while
   * accessing variables on the server
   */
  const content = await Markdoc.transform(ast, cfg);

  return {
    // Removes undefined
    props: JSON.parse(
      JSON.stringify({
        markdoc: {
          content,
          frontmatter,
          file: {
            path: filepath
          }
        },
      })
    ),
  };
}

export default function MarkdocComponent(props) {
  // Only execute HMR code in development
  return renderers.react(props.markdoc.content, React, {
    components: {
      ...components,
      // Allows users to override default components at runtime, via their _app
      ...props.components,
    },
  });
}
